import GenericRequest, { METHOD_POST } from '../../shared/webservices/GenericRequest';
import { ApiEndpoints } from '../../shared/webservices/endpoint';

export default class TypeDocumentsRequest extends GenericRequest {

    term;
    page;
    filter;

    constructor(page, term = '', filter = 0, limit = '') {
        super(METHOD_POST, ApiEndpoints.DOCUMENTS_TYPE);

        this.page = page;
        this.term = term;
        this.filter = filter;
        this.limit = limit;
    }

    overrideRequest() {
        const request = {};
        request.criteria = {};
        if ( this.page ) request.criteria.page = this.page;
        if ( this.term ) request.criteria.term = this.term;
        if ( this.filter && this.filter !== 0 ) request.criteria.document_schema_type_ids = [this.filter];
        if ( this.limit && this.limit !== '' ) request.criteria.limit = this.limit;
        return request;
    }
}



// WEBPACK FOOTER //
// ./src/app/documents/ws/TypeDocumentsRequest.js